import styled from "styled-components";

export const StyledHome = styled.div<{ mainColor: string }>`
    width: 100%;
    position: relative;
    /* overflow: scroll; */
    /* background-color: #fff; */
    /* margin-top: -112px; */
    .background {
        width: 100%;
        height: 50px;
        position: absolute;
        top: 112px;
        // background: linear-gradient(to bottom, ${(p) => p.theme.colors.home_bg}, transparent);
    }
    .ant-tabs-tab-active .ant-tabs-tab-btn {
        color: ${(p) => p.mainColor}!important;
    }
    .ant-tabs-tab:hover {
        color: ${(p) => p.mainColor}!important;
    }
    .button-layout {
        flex: 1;
        // padding: 4px;
        margin-top: 30px;
        .coupon-price {
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            color: ${(p) => p.theme.colors.color};
        }
        button {
            margin-right: 10px;
        }
        .btn-redeem {
            background-color: ${(p) => p.mainColor}!important;
            border-color: ${(p) => p.mainColor};
            color: #fff;
        }
    }
    .ant-tabs-ink-bar {
        background-color: ${(p) => p.mainColor};
        height: 3px !important;
        border-radius: 5px;
        width: 20px !important;
    }
    .preview {
        width: calc(100% - 30px);
        position: relative;
        background-color: ${(p) => p.theme.colors.card};
        color: ${(p) => p.theme.colors.color};
        background-repeat: no-repeat;
        background-position: 12px 12px;
        margin: 0 auto;
        box-shadow: 0px 0px 8px rgba(175, 175, 175, 0.16);
        padding: 25px 16px 20px;
        border-radius: 8px;
        border: 1px solid #c4a363;
        z-index: 2;
        .avatar-layout {
            display: flex;
            flex-direction: row-reverse;
        }
        .ant-avatar {
            cursor: pointer;
            border: 1px solid #c4a363;
        }
        .circle-avatar-user-layout {
            margin-top: -51px;
        }
        .circle-avatar-user {
            cursor: pointer;
            img {
                border-radius: 50%;
            }
        }
        .profile-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            /* margin-top: 10px; */
            .avatar_name {
                font-size: 20px;
                font-weight: 500;
                text-align: center;
                color: inherit;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                .name {
                    font-size: 20px;
                    line-height: 27px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    /* display: -webkit-box; */
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    word-break: break-word;
                    overflow: hidden;
                    max-width: 260px;
                    white-space: nowrap;
                    @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
                        max-width: 180px;
                    }
                    @media (max-width: ${(p) => p.theme.breakPoints.breakMobileLarge}) {
                        max-width: 150px;
                    }
                    @media (max-width: ${(p) => p.theme.breakPoints.breakMobile}) {
                        max-width: 100px;
                    }
                }
                .hello {
                    font-weight: 300;
                }
            }
            .user-actions {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .star {
                    cursor: pointer;
                    margin-right: 10px;
                    &:hover {
                        opacity: 0.8;
                        transition: 0.6s;
                    }
                }
                .rank-layout {
                }
            }
        }
        .good {
            text-align: center;
            color: inherit;
            font-weight: 500;
            font-size: 8px;
            line-height: 11px;
            padding: 4px 8px;
            background: #816b00;
            display: inline-block;
            border-radius: 12px;
            position: relative;
            margin-top: 12px;
            top: -8px;
            span {
                display: inline-block;
                margin: 0 4px;
                font-size: 11px;
            }
        }
        .user-progress {
            margin-bottom: 15px;
            .progress-info {
                display: flex;
                justify-content: space-between;
                &:first-child {
                    color: ${(p) => p.theme.colors.color};
                }

                p.label {
                    margin-top: 0.5em;
                    color: ${(p) => p.theme.colors.color};
                }
                p.text {
                    margin-top: 0.5em;
                    color: ${(p) => p.theme.colors.color};
                }
            }
        }
        .star_coupans {
            display: grid;
            align-items: center;
            grid-template-columns: 1fr 1fr;
            .point {
                color: ${(p) => p.mainColor};
                display: initial !important;
            }
            .coupon {
                color: ${(p) => p.theme.colors.color};
                display: initial !important;
            }
            .star_point:last-child {
                margin-right: 0;
            }
            .star_point {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                margin-right: 10px;
                box-shadow: 0px 3px 6px rgba(143, 143, 143, 0.16);
                padding: 8px 16px;
                background: ${(p) => p.theme.colors.card};
                border-radius: 14px;
                .control-detail {
                    margin-left: 20px;
                    span {
                        display: block;
                        cursor: pointer;
                        margin-top: 3px;
                        font-weight: 500;
                        line-height: 10px;
                    }
                }
            }
            .line {
                height: 40px;
                width: 1px;
                background-color: #707070;
                opacity: 0.5;
            }
            .desc {
                font-weight: normal;
                font-size: 10px;
                line-height: 13px;
                color: ${(p) => p.theme.colors.normal};
                position: relative;
                left: 2px;
                font-weight: 500 !important;
                cursor: pointer;
            }
        }
        .desc_end {
            font-weight: normal;
            font-size: 8px;
            line-height: 11px;

            width: 50%;
            text-align: center;
            color: #989898;
        }
    }
    .features {
        width: calc(100% - 30px);
        margin: 0 auto;
        margin-top: 16px;
        .card {
            padding: 12px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #fff;
            box-shadow: 0px 0px 8px rgb(175 175 175 / 16%);
            .title {
                display: flex;
                align-items: center;
                p {
                    margin: 0;
                    font-size: 12px;
                    line-height: 16px;
                    font-weight: 500;
                    color: #000;
                }
            }
        }
    }
    .nav-bar {
        padding: 3px 16px;
        background-color: transparent;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        margin-top: 4px;
        color: ${(p) => p.theme.colors.color};
        .item {
            text-align: center;
            padding: 15px 0 10px;
            line-height: 21px;
            color: #989898;
            cursor: pointer;
            position: relative;

            font-style: normal;
        }
        .under {
            color: inherit;
            font-size: 16px;
            &::after {
                content: "";
                position: absolute;
                bottom: 2px;
                left: 45%;
                width: 56%;
                height: 3px;
                background-color: ${(p) => p.mainColor};
                transform: translateX(-50%);
                border-radius: 5px;
            }
        }
    }
    .edit-profile-btn {
        display: flex;
        padding-top: 12px;
        font-size: 16px;
        font-weight: 600;
        width: 100%;
        height: 48px;
        border-radius: 100px;
        justify-content: center;
        outline: none;
        border-color: #a5a5a5;

        svg {
            margin-top: 3px;
            margin-right: 5px;
        }
    }
    .edit-profile-btn:hover {
        color: black;
        border-color: #a5a5a5;
    }
`;

export const StyledContainerHome = styled.div`
    background-color: transparent;
    .ant-empty {
        margin-top: 36px;
    }
`;
